import React from 'react';

/**
 * Archive icon used by the own-listing action bar.
 *
 * @param {Object} props
 * @param {string} [props.className] - Custom class for the SVG root
 * @returns {JSX.Element} archive icon
 */
const ArchiveIcon = props => {
  const { className } = props;

  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      role="none"
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M2.25 5.25h11.5v8.25H2.25z" />
        <path d="M1.5 2.5h13v2.75h-13zM6 8h4" />
      </g>
    </svg>
  );
};

export default ArchiveIcon;
